import { useAuthStoreUser } from '@gov-nx/store/auth/store';

export const useUserLoginInfo = () => {
	const { loa, loginType } = useAuthStoreUser();
	const databoxLogin = loginType === 'DS';

	const isLowLoa = loa === 'LOW';
	const isSubstantialLoa = loa === 'SUBSTANTIAL';
	const isHighLoa = loa === 'HIGH';

	return {
		loa,
		loginType,
		isLowLoa,
		isSubstantialLoa,
		isHighLoa,
		databoxLogin,
	};
};
